import React, {Fragment} from "react";
import Routes from "./routes/Routes";

import GlobalStyle from "./styles/GlobalStyle";
import AuthProvider from "./context/AuthProvider";

// inicio del app
function App() {
   return (
      <AuthProvider>
         <Fragment>
            <GlobalStyle />
            <Routes />
         </Fragment>
      </AuthProvider>
   );
}

export default App;
